__turbopack_context__.v({
  "arrow": "Popper-module-scss-module__ZRZ9ea__arrow",
  "bottom": "Popper-module-scss-module__ZRZ9ea__bottom",
  "container": "Popper-module-scss-module__ZRZ9ea__container",
  "content": "Popper-module-scss-module__ZRZ9ea__content",
  "dark": "Popper-module-scss-module__ZRZ9ea__dark",
  "left": "Popper-module-scss-module__ZRZ9ea__left",
  "light": "Popper-module-scss-module__ZRZ9ea__light",
  "right": "Popper-module-scss-module__ZRZ9ea__right",
  "top": "Popper-module-scss-module__ZRZ9ea__top",
});
